/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Usage_Status_BilledInputs */



/**
* | output |
* | --- |
* | "billed" |
*
* @param {Admin_Export_Usage_Status_BilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_status_billed = /** @type {((inputs?: Admin_Export_Usage_Status_BilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_Status_BilledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("abgerechnet")
	return /** @type {LocalizedString} */ ("billed")
});